import { cn } from 'ui';
import { newsreader } from '../../fonts/local.font';

// Novedades reads like a newspaper: serif for what is read, the app's sans for
// what is operated. The serif comes from a CSS variable, set where notes render.
export const editorialFontVariable = newsreader.variable;

export const editorialSerif = 'font-[family-name:var(--font-editorial)]';

// The reading column, and the wider room a demo breaks out to.
export const editorialColumn = 'mx-auto w-full max-w-[53.75rem]';

export const editorialWideColumn = 'mx-auto w-full max-w-[76rem]';

export const editorialBody = cn(
  editorialSerif,
  'text-lg text-foreground md:text-[1.3125rem]',
);

// RichText's paragraphs inside editorialBody.
export const editorialParagraph = 'mb-[1.1em] leading-[1.65]';

export const editorialSubhead = cn(
  editorialSerif,
  'font-semibold leading-[1.18] tracking-[-0.008em] text-foreground',
);

export const editorialLink =
  'decoration-1 underline-offset-[3px] hover:underline';
